let schoolMap = new Map();

const PREFECTURES = [
  "北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県",
  "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県",
  "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県",
  "岐阜県", "静岡県", "愛知県", "三重県", "滋賀県", "京都府",
  "大阪府", "兵庫県", "奈良県", "和歌山県",
  "鳥取県", "島根県", "岡山県", "広島県", "山口県",
  "徳島県", "香川県", "愛媛県", "高知県",
  "福岡県", "佐賀県", "長崎県", "熊本県", "大分県",
  "宮崎県", "鹿児島県", "沖縄県"
];

/* global escapeHtml, escapeAttr, normalizeHomepageUrl, buildPictureMarkup */
document.addEventListener("DOMContentLoaded", () => {
  initSchoolSearch();
});

// 検索結果ページの初期化と描画
function initSchoolSearch() {
  const container = document.querySelector(".js-school-search");
  if (!container) return;

  // 参照するDOMとルートパスを取得（テンプレートから相対パスを補正）
  const root = container.getAttribute("data-root") || "../";
  const resultList = container.querySelector(".js-school-result-list");
  const resultTotal = container.querySelector(".js-result-total");
  const noResults = container.querySelector(".js-no-results");
  const loadingIndicator = container.querySelector(".js-search-loading");
  const selectedList = container.querySelector(".js-selected-conditions");

  if (!resultList || !resultTotal || !noResults || !selectedList) return;

  const setLoadingState = (isLoading) => {
    if (!loadingIndicator) return;
    loadingIndicator.hidden = !isLoading;
  };

  // URLパラメータを読み取り、検索条件を組み立てる
  const params = new URLSearchParams(window.location.search);
  const freeword = normalizeFreeword(params.get("freeword"));

  const conditions = {
    shisetsukubun: getParamList(params, "shisetsukubun"),
    school_operator_type: getParamList(params, "settisya"),
    regional_scope: getParamList(params, "area_type"),
    establishment_type: getParamList(params, "dokuritsu_type"),
    program_duration_years: getParamList(params, "syugyo_type"),
    municipality: getParamList(params, "pref"),
    distance_learning_area: getParamList(params, "pref03"),
    dept_types: getParamList(params, "gakka"),
    facility_address_prefecture: getParamList(params, "pref02"),
  };

  // 学校データを取得して検索に利用する
  setLoadingState(true);
  loadSchoolsForSearch(root)
    .then((schools) => {

      // 🔥ここ！！！！
      schoolMap = new Map(
        schools.map(school => [String(school.id), school])
      );

      // フリーワードがあれば全文検索、なければ条件検索
      const records = flattenRecords(schools);

      const results = freeword
        ? filterByFreeword(records, freeword)
        : filterByConditions(records, conditions);

      results.sort((a, b) => {
        if (a.type === b.type) return 0;
        return a.type === "school" ? -1 : 1;
      });

      // 選択条件と検索結果を描画
      renderSelectedConditions(selectedList, freeword, conditions);
      const initialPage = Number.parseInt(params.get("page") || "1", 10);
      renderResults(
        resultList,
        resultTotal,
        noResults,
        results,
        root,
        Number.isFinite(initialPage) ? initialPage : 1,
      );
      setLoadingState(false);
    })
    .catch((err) => {
      setLoadingState(false);
      // eslint-disable-next-line no-console
      console.error(err);
      resultTotal.textContent = "検索結果 : 0 件";
      noResults.hidden = false;
    });
}

// 一覧用の学校データ取得（検索条件に使うソース）
function loadSchoolsForSearch(root) {
  const dataUrl = `${root}_data/_db/schools_with_partners.json`;

  return fetch(dataUrl).then((res) => {
    if (!res.ok) throw new Error(`Failed to load data: ${res.status}`);
    return res.json();
  });
}

// フリーワードの前後空白を除去して統一
function normalizeFreeword(value) {
  if (!value) return "";
  return value.trim();
}

// 検索比較用に全角・半角の差を吸収する
function normalizeSearchText(value) {
  return String(value || "")
    .normalize("NFKC")
    .toLowerCase();
}

// URLパラメータの複数値を配列で取得（チェックボックス対応）
function getParamList(params, key) {
  return params
    .getAll(key)
    .map((v) => v.trim())
    .filter((v) => v && v !== "on");
}

// フリーワードが任意の対象フィールドに含まれるかで絞り込み
function filterByFreeword(records, keyword) {

  if (!keyword) return records;

  const words = normalizeSearchText(keyword)
    .trim()
    .split(/\s+/);

  return records.filter(record => {

    const school = record.school;
    const partner = record.partner;

    const text = [
      school.school_name,
      school.municipality,
      school.establisher_name,
      school.school_address,
      partner?.facility_name,
      partner?.facility_address,
    ]
      .filter(Boolean)
      .join(" ")
      .normalize("NFKC")
      .toLowerCase();

    return words.every(word => text.includes(word));
  });
}

// 複数条件のANDで絞り込み
function filterByConditions(records, conditions) {

  return records.filter(record => {

    const school = record.school;
    const partner = record.partner;

    //-------------------------
    // 🔥 ① school条件（共通）
    //-------------------------

    const schoolMatch = (

      matchField(school.school_operator_type, conditions.school_operator_type) &&
      matchField(school.regional_scope, conditions.regional_scope) &&
      matchField(school.establishment_type, conditions.establishment_type) &&
      matchField(school.municipality, conditions.municipality) &&
      matchField(school.distance_learning_area, conditions.distance_learning_area) &&
      matchField(school.program_duration_years, conditions.program_duration_years) &&
      matchField(school.dept_types, conditions.dept_types)

    );

    if (!schoolMatch) return false;


    //-------------------------
    // 🔥 ② partner限定条件
    //-------------------------

    if (record.type === "partner") {

      if (conditions.facility_address_prefecture.length) {
        if (!conditions.facility_address_prefecture.includes(
          partner.facility_address_prefecture
        )) return false;
      }

    } else {
      // schoolカード時にpartner条件がONなら除外
      if (conditions.facility_address_prefecture.length) {
        return false;
      }
    }


    //-------------------------
    // 🔥 ③ shisetsukubun（施設区分）
    //-------------------------

    const selected = conditions.shisetsukubun;

    if (selected.length) {

      const match = (

        // 本校
        (selected.includes('本校') && record.type === 'school')

        ||

        // 面接
        (selected.includes('通信教育連携協力施設（面接指導等実施施設）') &&
          record.type === 'partner' &&
          partner.facility_type?.some(v =>
            v.includes('面接指導等')
          )
        )

        ||

        // 学習
        (selected.includes('通信教育連携協力施設（学習等支援施設）') &&
          record.type === 'partner' &&
          partner.facility_type?.some(v =>
            v.includes('学習等支援')
          )
        )

      );

      if (!match) return false;
    }

    return true;
  });
}

// 単一値の一致判定（未選択なら常に一致）
// function matchesMultiValue(value, selected) {
//   if (!selected.length) return true;
//   return selected.includes(value);
// }

// function matchField(recordValue, selected){

//   if(!selected.length) return true;

//   const values = Array.isArray(recordValue)
//     ? recordValue
//     : [recordValue];

//   return values.some(v => selected.includes(v));
// }

// 配列項目との一致判定（未選択なら常に一致）
function matchesArrayField(value, selected) {
  if (!selected.length) return true;
  if (!Array.isArray(value)) return false;
  return selected.some((v) => value.includes(v));
}

// 連携施設の都道府県条件に一致するか判定
function matchesPartnersPref(partners, selected) {
  if (!selected.length) return true;
  return partners.some((partner) =>
    selected.includes(partner.facility_address_prefecture),
  );
}

// 選択条件のラベルをタグとして表示
function renderSelectedConditions(container, freeword, conditions) {
  const tags = [];

  if (freeword) {
    tags.push(`フリーワード: ${freeword}`);
  } else {
    Object.values(conditions).forEach((values) => {
      values.forEach((value) => tags.push(value));
    });
  }

  if (!tags.length) {
    container.innerHTML = "<span>条件なし</span>";
    return;
  }

  container.innerHTML = tags
    .map(tag => {

      let className = "";

      if (tag === "本校") {
        className = "c-tag_shisetsu01";

      } else if (tag.includes("面接指導等実施施設")) {
        className = "c-tag_shisetsu02";

      } else if (tag.includes("学習等支援施設")) {
        className = "c-tag_shisetsu03";
      }

      return className
        ? `<span class="${className}">${escapeHtml(tag)}</span>`
        : `<span>${escapeHtml(tag)}</span>`;
    })
    .join("");
}

// 検索件数と結果一覧を描画（ページ送り対応）
function renderResults(list, total, noResults, results, root, initialPage) {
  const pageSize = 10;
  const searchResult = list.closest(".search_result");
  const pagination = searchResult
    ? searchResult.querySelector(".pagination")
    : null;
  const pageNumbers = pagination
    ? pagination.querySelector(".page_numbers")
    : null;
  const pageSelect = pagination
    ? pagination.querySelector(".js-page-select")
    : null;
  const prevLink = pagination
    ? pagination.querySelector(".page_nav_prev")
    : null;
  const nextLink = pagination
    ? pagination.querySelector(".page_nav_next")
    : null;

  const count = results.length;
  const totalPages = Math.ceil(count / pageSize);
  let currentPage = totalPages > 0 ? initialPage : 1;

  if (pagination && totalPages === 0) {
    pagination.hidden = true;
  }

  if (totalPages > 0) {
    currentPage = Math.min(Math.max(currentPage, 1), totalPages);
  }

  // 件数表示（0件時は固定表記）
  const updateTotalText = (page, totalCount) => {
    if (totalCount === 0) {
      total.textContent = "検索結果 : 0～0 件を表示 ／ 全 0 件";
      return;
    }

    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, totalCount);
    total.textContent = `検索結果 : ${start}～${end} 件を表示 ／ 全 ${totalCount} 件`;
  };

  // ページ番号配列を生成（多すぎる場合は省略表示）
  const buildPageItems = (pages, page) => {
    if (pages <= 5) {
      return Array.from({ length: pages }, (_, i) => i + 1);
    }

    const listPages = [1, pages, page - 1, page, page + 1]
      .filter((p) => p >= 1 && p <= pages)
      .sort((a, b) => a - b)
      .filter((p, index, array) => index === 0 || p !== array[index - 1]);

    const items = [];
    listPages.forEach((p, index) => {
      if (index > 0 && p - listPages[index - 1] > 1) {
        items.push("dots");
      }
      items.push(p);
    });

    return items;
  };

  // ページ送りUIを描画
  const renderPagination = () => {
    if (!pagination) return;

    pagination.hidden = totalPages <= 1;

    if (pageNumbers) {
      pageNumbers.innerHTML = buildPageItems(totalPages, currentPage)
        .map((item) => {
          if (item === "dots") {
            return `<a href="" class="page_number -dots" tabindex="-1">...</a>`;
          }
          const isCurrent = item === currentPage;
          return `<a href="" class="page_number${isCurrent ? " -current" : ""
            }" data-page="${item}">${item}</a>`;
        })
        .join("");
    }

    if (pageSelect) {
      pageSelect.innerHTML = Array.from({ length: totalPages }, (_, i) => {
        const page = i + 1;
        return `<option value="${page}">${page}/${totalPages} page</option>`;
      }).join("");
      pageSelect.value = String(currentPage);
    }

    if (prevLink) {
      prevLink.classList.toggle("-disabled", currentPage <= 1);
    }
    if (nextLink) {
      nextLink.classList.toggle("-disabled", currentPage >= totalPages);
    }
  };

  // ページ切替時に結果エリア先頭へスクロール
  const scrollToResultTop = () => {
    const target = list.closest("#result") || list.closest(".search_result");
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // 指定ページの結果を描画
  const renderPage = (page, shouldScroll = false) => {
    if (totalPages === 0) {
      list.innerHTML = "";
      updateTotalText(1, 0);
      noResults.hidden = false;
      if (pagination) pagination.hidden = true;
      return;
    }

    currentPage = Math.min(Math.max(page, 1), totalPages);
    const startIndex = (currentPage - 1) * pageSize;
    const pageItems = results.slice(startIndex, startIndex + pageSize);

    list.innerHTML = pageItems
      .map((record) => {

        if (record.type === "school") {
          return renderSchoolCard(record.school, root);
        }

        return renderPartnerCard(record.partner, record.school, root);
      })
      .join("");
    updateTotalText(currentPage, count);
    noResults.hidden = count > 0;
    renderPagination();
    if (shouldScroll) {
      scrollToResultTop();
    }
  };

  // ページ番号・前後リンクのクリック制御
  if (pagination && !pagination.dataset.bound) {
    pagination.addEventListener("click", (event) => {
      const link = event.target.closest("a");
      if (!link || !pagination.contains(link)) return;

      event.preventDefault();

      if (
        link.classList.contains("-dots") ||
        link.classList.contains("-disabled")
      ) {
        return;
      }

      if (link.classList.contains("page_nav_prev")) {
        renderPage(currentPage - 1, true);
        return;
      }

      if (link.classList.contains("page_nav_next")) {
        renderPage(currentPage + 1, true);
        return;
      }

      const pageValue = Number.parseInt(
        link.getAttribute("data-page") || "",
        10,
      );
      if (Number.isFinite(pageValue)) {
        renderPage(pageValue, true);
      }
    });

    pagination.dataset.bound = "true";
  }

  // セレクトボックスでのページ移動
  if (pageSelect && !pageSelect.dataset.bound) {
    pageSelect.addEventListener("change", (event) => {
      const target = event.currentTarget;
      const pageValue = Number.parseInt(target.value, 10);
      if (Number.isFinite(pageValue)) {
        renderPage(pageValue, true);
      }
    });
    pageSelect.dataset.bound = "true";
  }

  renderPage(currentPage);
}

// 連携協力施設セクションのHTMLを生成（一覧用）
function renderPartnerSectionForList(partners, school, root) {
  if (!partners.length) return "";

  return `
    <div class="support_area">
      <p class="subtitle">学習等支援施設情報</p>
      <div class="support_list">
        ${partners
      .map((partner) => renderPartnerBlockForList(partner, school, root))
      .join("")}
      </div>
    </div>
  `;
}

// 連携協力施設のテーブルとアクションを生成（一覧用）
function renderPartnerBlockForList(partner, school, root) {
  // const types = Array.isArray(partner.facility_type) ? partner.facility_type : [];
  // const typeTags = types
  //  .map((type) => `<span class="-active">${escapeHtml(type)}</span>`)
  //  .join("");
  const typeTags = "";
  const facilityName = String(partner.facility_name || "").trim();
  // const homepageLabel = facilityName
  //   ? `${facilityName}公式サイト`
  //   : "公式サイト";
  const homepageLabel = "公式サイト";
  const homepageUrl = String(partner.facility_homepage_url || "").trim();
  const homepageInfo = normalizeHomepageUrl(homepageUrl);
  const homepageClass = homepageInfo.isValid
    ? "btn c-btn_link"
    : "btn c-btn_link -disabled";
  const infoLabel = "情報公開ページ";
  const infoUrl = String(partner.info_url || "").trim();
  const infoInfo = normalizeHomepageUrl(infoUrl);
  const infoClass = infoInfo.isValid
    ? "btn c-btn_link"
    : "btn c-btn_link -disabled";
  const facilityImageMarkup = buildPictureMarkup(
    root,
    "school_img",
    partner.img ? partner.id : null,
    partner.facility_name,
  );
  const facilityArray = Array.isArray(partner.facility_type)
    ? partner.facility_type
    : [];

  let facilityTypeLabel = '';

  if (facilityArray.some(v => v.includes('面接指導等'))) {
    facilityTypeLabel = '<span class="c-tag_shisetsu02">通信教育連携協力施設（面接指導等実施施設）</span>';
  }
  else if (facilityArray.some(v => v.includes('学習等支援'))) {
    facilityTypeLabel = '<span class="c-tag_shisetsu03">通信教育連携協力施設（学習等支援施設）</span>';
  }

  return `
    <div class="tags">
      ${facilityTypeLabel}
    </div>
    <div class="info_area">
      <div class="wrap">
        <div class="img">
          ${facilityImageMarkup}
        </div>
        <div class="table">
          <dl class="-long">
            <dt>通信教育連携協力施設名</dt>
            <dd>${escapeHtml(partner.facility_name || "")}</dd>
          </dl>
          <dl class="-long">
            <dt>所在地</dt>
            <dd>${escapeHtml(partner.facility_address || "")}</dd>
          </dl>
          <dl class="-long">
            <dt>収容定員数</dt>
            <dd>${escapeHtml(formatCapacity(partner.capacity))}</dd>
          </dl>
          <dl class="-long">
            <dt>在籍生徒数</dt>
            <dd>${escapeHtml(partner.enrollment_count ? partner.enrollment_count.toLocaleString() + "人" : "-")}</dd>
          </dl>
          <div class="card_note">
            ※掲載情報は令和８年４月１日時点のものです。なお、在籍者数については入学式の日時点としています。
          </div>
        </div>
      </div>
      <div class="action">
        <a href="${escapeAttr(
    homepageInfo.href,
  )}" class="${homepageClass}" target="_blank" rel="noopener noreferrer">${escapeHtml(
    homepageLabel,
  )}</a>
        <a href="${escapeAttr(
    infoInfo.href,
  )}" class="${infoClass}" target="_blank" rel="noopener noreferrer">${escapeHtml(
    infoLabel,
  )}</a>

        <a href="#" 
          class="btn c-btn_link js-open-school-modal"
          data-school-id="${school.id}">
          本校情報
        </a>
      </div>
    </div>
  `;
}

// info_area のアクションリンク群を生成（一覧用）
function buildSchoolActionLinksForList(school) {
  const schoolName = String(school.school_name || "").trim();
  const homepageUrl = String(school.homepage_url || "").trim();
  // const homepageLabel = schoolName ? `${schoolName}公式サイト` : "公式サイト";
  const homepageLabel = "公式サイト";
  const homepageInfo = normalizeHomepageUrl(homepageUrl);
  const homepageClass = homepageInfo.isValid
    ? "btn c-btn_link"
    : "btn c-btn_link -disabled";
  const homepageHref = homepageInfo.href;
  const infoUrl = String(school.info_url || "").trim();
  // const infoLabel = schoolName ? `${schoolName}公式サイト` : "公式サイト";
  const infoLabel = "情報公開ページ";
  const infoInfo = normalizeHomepageUrl(infoUrl);
  const infoClass = infoInfo.isValid
    ? "btn c-btn_link"
    : "btn c-btn_link -disabled";
  const infoHref = infoInfo.href;
  return `
    <a href="${escapeAttr(
    homepageHref,
  )}" class="${homepageClass}" target="_blank" rel="noopener noreferrer">${escapeHtml(
    homepageLabel,
  )}</a>
    <a href="${escapeAttr(
    infoHref,
  )}" class="${infoClass}" target="_blank" rel="noopener noreferrer">${escapeHtml(
    infoLabel,
  )}</a>
  `;
}

// 学校カードのHTMLを生成（一覧表示の1件分）
function renderSchoolCard(school, root) {
  const distanceArea = Array.isArray(school.distance_learning_area)
    ? school.distance_learning_area.join("　")
    : "";
  const deptTypes = Array.isArray(school.dept_types)
    ? school.dept_types.join("、")
    : "";

  const tags = [school.school_operator_type || ""].filter(Boolean);

  const partners = Array.isArray(school.partners) ? school.partners : [];
  const partnersHtml = renderPartnerSectionForList(partners, root);

  const actionLinks = buildSchoolActionLinksForList(school);
  const schoolImageMarkup = buildPictureMarkup(
    root,
    "school_img",
    school.img ? school.id : null,
    school.school_name,
  );

  return `
    <div class="card">
      <div class="header">
        <h3 class="name">
          ${escapeHtml(school.school_name || "")}
          ${school.school_name_note
      ? '<br><span class="note">' + escapeHtml(school.school_name_note) + '</span>'
      : ''}
          </h3>
      </div>
      <div class="tags">
        <span class="c-tag_shisetsu01">本校</span>
        ${tags.map((tag) => `<span>${escapeHtml(tag)}</span>`).join("")}
      </div>
      <div class="info_area">
        <div class="wrap">
          <div class="img">
            ${schoolImageMarkup}
          </div>
          <div class="table">
            <dl class="-long">
              <dt>所在地</dt>
              <dd>
                ${escapeHtml(school.school_address || "")}
                ${school.school_address_note
      ? '<br><span class="note">' + escapeHtml(school.school_address_note) + '</span>'
      : ''}
              </dd>
            </dl>
            <dl class="-long">
              <dt>設置者名</dt>
              <dd>${escapeHtml(school.establisher_name || "")}</dd>
            </dl>
            <dl>
              <dt>独立併置の別</dt>
              <dd>${escapeHtml(school.establishment_type || "")}</dd>
            </dl>
            <dl>
              <dt>広域狭域の別</dt>
              <dd>${escapeHtml(school.regional_scope || "")}</dd>
            </dl>
            <dl class="-long">
              <dt>通信教育を<br class="none-sp">行う区域</dt>
              <dd>${escapeHtml(distanceArea)}</dd>
            </dl>
            <dl>
              <dt>設置学科</dt>
              <dd>${escapeHtml(deptTypes)}</dd>
            </dl>
            <dl>
              <dt>修業年限</dt>
              <dd>${escapeHtml(school.program_duration_years || "")}</dd>
            </dl>
            <dl>
              <dt>収容定員数</dt>
              <dd>${escapeHtml(school.capacity ? school.capacity.toLocaleString() + "人" : "-")}</dd>
            </dl>
            <dl>
              <dt>在籍生徒数</dt>
              <dd>${escapeHtml(school.enrollment ? school.enrollment.toLocaleString() + "人" : "-")}</dd>
            </dl>
            <dl class="-long">
              <dt>通信教育<br class="none-sp">連携協力施設数</dt>
              <dd>${escapeHtml(school.partner_facility_count ? school.partner_facility_count.toLocaleString() : "-")}</dd>
            </dl>
            <div class="card_note">
              ※掲載情報は令和８年４月１日時点のものです。なお、在籍者数については入学式の日時点としています。
            </div>
          </div>
        </div>
        <div class="action">
          ${actionLinks}
        </div>
      </div>
    </div>
  `;
}

// 詳細ページURLを現在の検索条件付きで生成
function buildDetailUrl(schoolId, root) {
  const params = new URLSearchParams(window.location.search);
  params.set("id", String(schoolId));
  const query = params.toString();
  return `${root}school/detail/${query ? `?${query}` : ""}`;
}

function flattenRecords(schools) {
  const records = [];

  schools.forEach(school => {

    // 学校
    records.push({
      type: "school",
      school,
    });

    // partner
    (school.partners || []).forEach(partner => {
      records.push({
        type: "partner",
        partner,
        school, // ←親も持たせる（超重要）
      });
    });

  });

  return records;
}

function renderPartnerCard(partner, school, root) {

  return `
    <div class="card -partner">
      <div class="header">
        <h3 class="name">${escapeHtml(school.school_name)}　連携　${escapeHtml(partner.facility_name)}</h3>
      </div>
      ${renderPartnerBlockForList(partner, school, root)}
    </div>
  `;
}

document.addEventListener("click", e => {

  const btn = e.target.closest(".js-open-school-modal");
  if (!btn) return;

  e.preventDefault();

  const schoolId = btn.dataset.schoolId;
  const school = schoolMap.get(schoolId);

  if (!school) return;

  openSchoolModal(school);
});

function openSchoolModal(school) {

  const body = document.getElementById("school-modal-body");

  if (!body) {
    console.error("school-modal-body が存在しない");
    return;
  }
  const actionLinks = buildSchoolActionLinksForList(school);
  const schoolImageMarkup = buildPictureMarkup(
    "../",
    "school_img",
    school.img ? school.id : null,
    school.school_name,
  );
  const distanceArea = Array.isArray(school.distance_learning_area)
    ? school.distance_learning_area.join(" ")
    : "";
  const deptTypes = Array.isArray(school.dept_types)
    ? school.dept_types.join("、")
    : "";
  const tags = [school.school_operator_type || ""].filter(Boolean);
  body.innerHTML = `
    <div class="card">
      <div class="header">
        <h3 class="name">${escapeHtml(school.school_name || "")}
          ${school.school_name_note
      ? '<br><span class="note">' + escapeHtml(school.school_name_note) + '</span>'
      : ''}
        </h3>
      </div>
      <div class="tags">
        <span class="c-tag_shisetsu01">本校</span>
        ${tags.map((tag) => `<span>${escapeHtml(tag)}</span>`).join("")}
      </div>
      <div class="info_area">
        <div class="wrap">
          <div class="img">
            ${schoolImageMarkup}
          </div>
          <div class="table">
            <dl class="-long">
              <dt>所在地</dt>
              <dd>
                ${escapeHtml(school.school_address || "")}
                ${school.school_address_note
      ? '<br><span class="note">' + escapeHtml(school.school_address_note) + '</span>'
      : ''}
              </dd>
            </dl>
            <dl class="-long">
              <dt>設置者名</dt>
              <dd>${escapeHtml(school.establisher_name || "")}</dd>
            </dl>
            <dl>
              <dt>独立併置の別</dt>
              <dd>${escapeHtml(school.establishment_type || "")}</dd>
            </dl>
            <dl>
              <dt>広域狭域の別</dt>
              <dd>${escapeHtml(school.regional_scope || "")}</dd>
            </dl>
            <dl class="-long">
              <dt>通信教育を<br class="none-sp">行う区域</dt>
              <dd>${escapeHtml(distanceArea)}</dd>
            </dl>
            <dl>
              <dt>設置学科</dt>
              <dd>${escapeHtml(deptTypes)}</dd>
            </dl>
            <dl>
              <dt>修業年限</dt>
              <dd>${escapeHtml(school.program_duration_years || "")}</dd>
            </dl>
            <dl>
              <dt>収容定員数</dt>
              <dd>${escapeHtml(school.capacity ? school.capacity.toLocaleString() + "人" : "-")}</dd>
            </dl>
            <dl>
              <dt>在籍生徒数</dt>
              <dd>${escapeHtml(school.enrollment ? school.enrollment.toLocaleString() + "人" : "-")}</dd>
            </dl>
            <dl class="-long">
              <dt>通信教育<br class="none-sp">連携協力施設数</dt>
              <dd>${escapeHtml(school.partner_facility_count.toLocaleString() || "0")}</dd>
            </dl>
            <div class="card_note">
              ※掲載情報は令和８年４月１日時点のものです。なお、在籍者数については入学式の日時点としています。
            </div>
          </div>
        </div>
        <div class="action">
          ${actionLinks}
        </div>
      </div>
    </div>
  `;

  document.getElementById("school-modal").hidden = false;
}

function expandDistanceArea(value) {

  if (!value) return [];

  // カンマで分解
  const tokens = value.split(",").map(v => v.trim()).filter(Boolean);

  let result = [];

  tokens.forEach(token => {

    // 47都道府県
    if (token === "47都道府県") {
      result.push(...PREFECTURES);
      return;
    }

    // ◯◯都道府県（◯◯を除く）
    if (token.includes("都道府県")) {

      let list = [...PREFECTURES];

      const excludeMatch = token.match(/（(.+?)を除く）/);
      if (excludeMatch) {
        const exclude = excludeMatch[1].trim();
        list = list.filter(p => p !== exclude);
      }

      result.push(...list);
      return;
    }

    // それ以外（海外など）
    result.push(token);

  });

  return [...new Set(result)];
}

// 収容定員数の表示用フォーマット
// 数字のみ → "1,200人" / 数字+テキスト → "1,200人（本校と合計）" / "定めていない"・空 → "-"
function formatCapacity(capacity) {
  if (capacity == null || capacity === "" || capacity === "定めていない") {
    return "-";
  }

  if (typeof capacity === "number") {
    return Number.isFinite(capacity) ? capacity.toLocaleString() + "人" : "-";
  }

  const str = String(capacity).trim();
  if (!str || str === "定めていない") return "-";

  // 先頭の数字（カンマ可）とそれ以降のテキストに分割
  const match = str.match(/^([\d,]+)(.*)$/);
  if (!match) return "-";

  const num = Number(match[1].replace(/,/g, ""));
  if (!Number.isFinite(num)) return "-";

  const suffix = match[2];
  return num.toLocaleString() + "人" + suffix;
}

function matchField(recordValue, selected) {

  if (!selected.length) return true;

  const rawValues =
    recordValue === null || recordValue === undefined
      ? []
      : Array.isArray(recordValue)
        ? recordValue
        : [recordValue];

  const values = rawValues
    .map((value) => {
      if (typeof value === "number") return String(value);
      if (typeof value === "string") return value.trim();
      return null;
    })
    .filter((value) => typeof value === "string" && value.length);

  if (!values.length) return false;

  return values.some((value) => {

    // 🔥 distance_learning_area用拡張判定
    if (value.includes("都道府県")) {
      const expanded = expandDistanceArea(value);
      return expanded.some((area) => selected.includes(area));
    }

    // 通常一致
    return selected.some((sel) => value.startsWith(sel));
  });
}

document.addEventListener("click", e => {

  if (!e.target.closest(".js-close-modal")) return;

  document.getElementById("school-modal").hidden = true;

});